import * as React from 'react';
import { ReactComponent as AlertIconSVG } from '../../assets/icons/mevo/ic_alert.svg';
import IconPattern, { IconProps } from './_IconPattern';

const AlertIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={AlertIconSVG} variantPlaces={1} {...props} />;
};

export default AlertIcon;
